<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    primaryColor: {
      type: String,
      default: '#F9FAFF',
    },
    secondaryColor: {
      type: String,
      default: '#D8DFF6',
    },
  },
};
</script>

<template>
  <content-loader
    width="600"
    height="160"
    viewBox="0 0 316 437"
    :speed="2"
    :primaryColor="primaryColor"
    :secondaryColor="secondaryColor"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="11" y="11" width="550" height="33" rx="4" />
    <rect x="11" y="61" width="550" height="33" rx="4" />
    <rect x="11" y="111" width="550" height="33" rx="4" />
  </content-loader>
</template>
